
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Layout = APP.module('Layout');

	Layout.MobileMenu = Layout.MobileMenu.extend({
		template: JST.AflClubsMobileMenu,
		site_title: 'Tipping',
		updateModel: function() {
			this.model.set({
				project_name: CONFIG.IMAGES_URL,
				items:        this.collection.toJSON(),
				user:         this.user.toJSON(),
				subMenuItems: this.subMenuItems.toJSON(),
				title:        this.site_title
			});

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));